module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('header', {
    staticClass: "bar bar-nav"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("设置发票信息")]), _vm._v(" "), _c('router-link', {
    staticClass: "button button-link button-nav pull-left",
    attrs: {
      "to": {
        name: 'orderContentConfirm'
      }
    }
  }, [_c('span', {
    staticClass: "icon icon-left",
    staticStyle: {
      "font-size": "18px"
    }
  }, [_vm._v("返回")])])], 1), _vm._v(" "), _vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "checkout-title"
  }, [_c('span', [_vm._v("发票类型")])]), _vm._v(" "), _c('div', {
    staticClass: "list-block media-list",
    staticStyle: {
      "margin-top": "1px",
      "margin-bottom": "2px"
    }
  }, [_c('ul', [_c('li', [_c('div', {
    staticClass: "item-inner",
    staticStyle: {
      "left": "10px"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "item-title button col-50"
  }, [_vm._v("增值税发票(普通)")]), _vm._v(" "), _c('div', {
    staticClass: "item-title-after button col-50"
  }, [_vm._v("增值税发票")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "checkout-title"
  }, [_c('span', [_vm._v("发票抬头")])]), _vm._v(" "), _c('div', {
    staticClass: "list-block",
    staticStyle: {
      "margin-top": "2px",
      "margin-bottom": "2px"
    }
  }, [_c('ul', [_c('li'), _c('li', [_c('div', {
    staticClass: "item-content"
  }, [_c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "item-input"
  }, [_c('input', {
    attrs: {
      "type": "text",
      "placeholder": "请填写单位名称"
    }
  })])])])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "item-content"
  }, [_c('div', {
    staticClass: "item-inner"
  }, [_c('div', {
    staticClass: "item-input"
  }, [_c('input', {
    attrs: {
      "type": "phoneNumber",
      "placeholder": "请填写纳税人识别号"
    }
  })])])])]), _vm._v(" "), _c('li')])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0cb6c018","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./script/loaders/emktVueLoader.js!./src/views/Order/Detail/InvoiceDetail.vue
// module id = 1532
// module chunks = 8